module.exports = {"id":"7647","name":"Dario Dainelli","rating":"76","photo":"./data/images/photos/2/7647.png","club":{"name":"Chievo Vérone","logo":"./data/images/clubs/ChievoVerone.png"},"positions":["DC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DarioDainelli0.json
// module id = 972
// module chunks = 0